export default {
    type: 'default',
    message: 'default text'
}